import type { AxiosAsyncStatus } from '@/@bothrs-react/hooks/useAxiosAsync'
import type { Appointment } from '@/modules/appointment/types/appointment.types'
import type { Encounter } from '@/modules/encounter/types/encounter.types'

enum TimelineErrorState {
  /**
   * Error when the user is not found. (404)
   */
  NOT_FOUND = 'NOT_FOUND',
  /**
   * Error when the user is not authorized. (401)
   */
  INTRAMUROS_TOKEN_EXPIRED = 'INTRAMUROS_TOKEN_EXPIRED',
  /**
   * Generic error. (any other error)
   */
  GENERIC = 'GENERIC',
}

/**
 * Context type for all props that is shared in all timeline page.
 */
type TimelineContextType = {
  appointments: {
    value: Appointment[] | undefined
    status: AxiosAsyncStatus
    isLoading: boolean
  }
  encounters: {
    value: Encounter[] | undefined
    status: AxiosAsyncStatus
    isLoading: boolean
  }
  isLoading: boolean
  error?: TimelineErrorState
  hasIntramurosPermission?: boolean
  intramurosName?: string
  forceReload: () => void
  /**
   * Holds a change the patient just made over the fetched list until the next
   * load brings the server's own answer in.
   *
   * `forceReload` is not an option for this: it puts the whole timeline into
   * its loading state, which unmounts the detail page and remounts it with the
   * old value. Without the hold, leaving the page and coming back would show
   * the appointment as it was before the change.
   */
  patchAppointment: (id: number, patch: Partial<Appointment>) => void
}

export type { TimelineContextType }
export { TimelineErrorState }
